import * as React from "react";
import {FormsColumn} from "./FormsColumn";

export class FormsRow extends React.Component<FormsRowProps, FormsRowState> {
    static defaultProps: Partial<FormsRowProps> = {};

    constructor(props: FormsRowProps) {
        super(props);
        this.state = {};
    }

    public render() {

        return (
            <tr>
                {formsVar.Design.Columns.map(column=>
                    <FormsColumn  Column={column} Data={this.props.Data}/>
                )}
            </tr>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FormsRowProps {
    Data:any;
}

interface FormsRowState {

}

//#endregion "My Region"